import React from 'react';

export function PageHeader({ title, subtitle, right, testId }) {
  return (
    <div className="flex items-start justify-between gap-4 mb-8" data-testid={testId}>
      <div>
        <h1 className="font-display text-3xl sm:text-4xl font-extrabold tracking-tight">{title}</h1>
        {subtitle && <p className="text-slate-500 mt-1">{subtitle}</p>}
      </div>
      {right}
    </div>
  );
}

export function StatCard({ label, value, icon: Icon, accent='blue', testId }) {
  const accents = {
    blue: 'bg-blue-50 text-blue-700',
    amber: 'bg-amber-50 text-amber-700',
    emerald: 'bg-emerald-50 text-emerald-700',
    violet: 'bg-violet-50 text-violet-700',
    orange: 'bg-orange-50 text-orange-700',
    rose: 'bg-rose-50 text-rose-700',
  };
  return (
    <div data-testid={testId} className="rounded-2xl bg-white p-6 border border-slate-200 hover:-translate-y-1 hover:shadow-md transition-all duration-200">
      <div className="flex items-center justify-between mb-3">
        <div className="text-xs uppercase tracking-widest text-slate-500 font-bold">{label}</div>
        {Icon && <div className={`w-9 h-9 rounded-xl grid place-items-center ${accents[accent]}`}><Icon className="w-4 h-4"/></div>}
      </div>
      <div className="font-display text-3xl font-extrabold">{value}</div>
    </div>
  );
}

export function EmptyState({ title, description, action }) {
  return (
    <div className="text-center py-16 rounded-2xl border border-dashed border-slate-300 bg-white/50">
      <div className="font-display text-xl font-bold mb-1">{title}</div>
      <div className="text-slate-500 text-sm mb-4">{description}</div>
      {action}
    </div>
  );
}
